import { useCallback } from 'react';
import { AUTH_BYPASS, acquireApiToken } from '../config/auth';
import { API_BASE_URL } from '../config/api';

/**
 * Returns a `fetch`-like function that attaches an MSAL access token to
 * outgoing requests against the app-purchasing API.
 *
 *   const apiFetch = useApi();
 *   const data = await apiFetch('/vendors').then(r => r.json());
 */
export function useApi() {
  return useCallback(
    async (path: string, init: RequestInit = {}): Promise<Response> => {
      const url = path.startsWith('http')
        ? path
        : `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

      const headers = new Headers(init.headers);
      if (!headers.has('Content-Type') && init.body) {
        headers.set('Content-Type', 'application/json');
      }

      if (!AUTH_BYPASS) {
        const token = await acquireApiToken();
        headers.set('Authorization', `Bearer ${token}`);
      }

      return fetch(url, { ...init, headers });
    },
    [],
  );
}
